export function Datenschutz() {
  return (
    <div className="bg-white p-5 shadow-md rounded-md max-w-3xl mx-auto">
      <a 
        href="#home"
        className="inline-block mb-6 px-3 py-1 bg-orange-100 hover:bg-orange-200 text-orange-800 rounded-md text-sm transition-colors"
      >
        ← Zurück zur Startseite
      </a>
      
      <h1 className="text-2xl font-bold mb-6 text-orange-800">Datenschutzerklärung</h1>
      
      <div className="space-y-6">
        <section>
          <h2 className="text-xl font-semibold mb-2 text-orange-700">Verantwortlicher</h2>
          <p>Diese Website wird von einer Privatperson betrieben:</p>
          <address className="not-italic mt-2">
            <p>Alexander Di Bernardo</p>
            <p>Oberdorfer Straße 11a/4</p>
            <p>9554 St. Urban</p>
            <p>Österreich</p>
            <p>E-Mail: alexander@di-bernardo.eu</p>
            <p>Telefon: 0650/415 45 82</p>
          </address>
        </section>
        
        <section>
          <h2 className="text-xl font-semibold mb-2 text-orange-700">Allgemeine Hinweise</h2>
          <p>
            Diese Website wird als privates Projekt betrieben und unterliegt nicht der Datenschutz-Grundverordnung (DSGVO), 
            da sie rein privaten Zwecken dient. Dennoch ist mir der Schutz Ihrer Daten wichtig. Aus diesem Grund speichere ich 
            nur die für den Betrieb und die Verbesserung der Website notwendigen Daten.
          </p>
          <p className="mt-2">
            Diese Datenschutzerklärung informiert Sie über den Umgang mit Ihren Daten bei der Nutzung dieser Website.
          </p>
        </section>
        
        <section>
          <h2 className="text-xl font-semibold mb-2 text-orange-700">Datenerfassung auf dieser Website</h2>
          <h3 className="text-lg font-medium mt-4 mb-1">Berechnung der Versicherungssteuer</h3>
          <p>
            Die Berechnungen erfolgen ausschließlich lokal in Ihrem Browser. Es werden keine Berechnungsdaten
            oder persönliche Informationen auf Servern gespeichert. Der MVS-Rechner verwendet keine Datenbank
            zum Speichern Ihrer Fahrzeug- oder Berechnungsdaten.
          </p>
          
          <h3 className="text-lg font-medium mt-4 mb-1">Firebase Realtime Database für den Like-Zähler</h3>
          <p>
            Diese Website nutzt Firebase Realtime Database, einen Dienst der Google Ireland Limited („Google"), 
            ausschließlich für die Speicherung eines einfachen "Gefällt mir"-Zählers. Die gespeicherten Daten umfassen nur:
          </p>
          <ul className="list-disc ml-6 mt-2">
            <li>Einen anonymen Zähler, der angibt, wie oft Benutzer den "Gefällt mir"-Button geklickt haben</li>
          </ul>
          <p className="mt-2">
            Es werden keine Berechnungsdaten, Fahrzeugdaten oder persönliche Informationen in dieser Datenbank
            gespeichert. Die Verwendung des Like-Buttons ist vollständig anonym und erfolgt nur, wenn Sie der
            Datenverarbeitung zugestimmt haben. Ohne Ihre Zustimmung wird der Zähler nur lokal in Ihrem Browser
            inkrementiert, aber nicht in der Datenbank gespeichert.
          </p>
          
          <h3 className="text-lg font-medium mt-4 mb-1">Google Analytics</h3>
          <p>
            Diese Website nutzt Google Analytics 4 (GA4), einen Webanalysedienst der Google Ireland Limited („Google"). 
            Google Analytics verwendet sogenannte „Cookies", Textdateien, die auf Ihrem Computer gespeichert werden 
            und die eine Analyse der Benutzung der Website durch Sie ermöglichen.
          </p>
          <p className="mt-2">
            Die durch das Cookie erzeugten Informationen über Ihre Benutzung dieser Website werden in der Regel an 
            einen Server von Google übertragen und dort gespeichert. Google Analytics erfasst unter anderem folgende Daten:
          </p>
          <ul className="list-disc ml-6 mt-2">
            <li>Anonymisierte IP-Adresse</li>
            <li>Besuchszeitpunkt und -dauer</li>
            <li>Besuchte Seiten</li>
            <li>Nutzung von Funktionen (z.B. Berechnungen, Teilen)</li>
            <li>Informationen über Browser, Betriebssystem und Gerät</li>
            <li>Referrer (vorher besuchte Website)</li>
          </ul>
          
          <p className="mt-2">
            Ich habe die IP-Anonymisierung auf dieser Website aktiviert. Dadurch wird Ihre IP-Adresse von Google 
            innerhalb von Mitgliedstaaten der Europäischen Union oder in anderen Vertragsstaaten des Abkommens über den 
            Europäischen Wirtschaftsraum vor der Übermittlung gekürzt. Nur in Ausnahmefällen wird die volle IP-Adresse 
            an einen Server von Google übertragen und dort gekürzt.
          </p>
          
          <p className="mt-2">
            Die Nutzung von Google Analytics erfolgt auf Grundlage unseres berechtigten Interesses an der 
            Analyse und Verbesserung unserer Website. Die gesammelten Daten werden nicht mit anderen Daten zusammengeführt, 
            die Rückschlüsse auf Ihre Identität zulassen könnten.
          </p>
          
          <h3 className="text-lg font-medium mt-4 mb-1">Widerspruchsmöglichkeit (Opt-Out)</h3>
          <p>
            Sie können der Erfassung und Verarbeitung Ihrer Daten durch Google Analytics und Firebase jederzeit widersprechen:
          </p>
          <ul className="list-disc ml-6 mt-2">
            <li>Durch Klick auf "Cookie-Einstellungen" am unteren rechten Bildschirmrand</li>
            <li>Durch Verwendung des "Cookie-Einstellungen zurücksetzen"-Links am Ende dieser Seite</li>
            <li>Durch Aktivierung des <a href="https://tools.google.com/dlpage/gaoptout?hl=de" target="_blank" rel="noopener noreferrer" className="text-orange-600 hover:underline">Browser-Add-ons zur Deaktivierung von Google Analytics</a></li>
            <li>Durch Deaktivieren von JavaScript in Ihrem Browser (kann die Funktionalität der Website einschränken)</li>
          </ul>
          
          <p className="mt-2">
            Wenn Sie der Verwendung von Google Analytics und Firebase zugestimmt haben, werden Cookies mit einer Speicherdauer 
            von maximal 14 Monaten gesetzt. Ohne Ihre Zustimmung werden keine Tracking-Cookies gesetzt und keine Berechnungsdaten gespeichert.
          </p>
          
          <h3 className="text-lg font-medium mt-4 mb-1">Cookies und lokale Speicherung</h3>
          <p>
            Diese Website verwendet folgende Cookies und lokale Speichermechanismen:
          </p>
          <ul className="list-disc ml-6 mt-2">
            <li>
              <strong>analytics-consent:</strong> Speichert Ihre Cookie-Präferenzen im Local Storage des Browsers. 
              Enthält nur die Information, ob Sie der Datenerfassung zugestimmt haben oder nicht.
            </li>
            <li>
              <strong>_ga, _ga_*, _gid:</strong> Google Analytics Cookies zur Analyse des Nutzerverhaltens.
              Werden nur gesetzt, wenn Sie der Verwendung von Google Analytics zugestimmt haben.
            </li>
          </ul>
          <p className="mt-2">
            Der MVS-Rechner verwendet den Local Storage des Browsers, um temporäre Eingaben zu speichern und
            die Benutzerfreundlichkeit zu verbessern. Diese Daten werden nicht an unsere Server übertragen und verbleiben
            ausschließlich auf Ihrem Gerät.
          </p>
          
          <h3 className="text-lg font-medium mt-4 mb-1">Server-Log-Dateien</h3>
          <p>
            Der Hosting-Provider dieser Website speichert möglicherweise automatisch Informationen in sogenannten Server-Log-Dateien,
            die Ihr Browser automatisch übermittelt. Dies ist ein technisch notwendiger Vorgang, auf den ich als Betreiber dieser 
            privaten Website keinen Einfluss habe. Typischerweise können dies folgende Daten sein:
          </p>
          <ul className="list-disc ml-6 mt-2">
            <li>Browsertyp und Browserversion</li>
            <li>Verwendetes Betriebssystem</li>
            <li>Referrer URL</li>
            <li>Hostname des zugreifenden Rechners</li>
            <li>Uhrzeit der Serveranfrage</li>
            <li>IP-Adresse</li>
          </ul>
          <p className="mt-2">
            Diese Daten werden nicht mit anderen Datenquellen zusammengeführt und dienen ausschließlich der Gewährleistung 
            eines störungsfreien Betriebs der Website.
          </p>
        </section>
        
        <section>
          <h2 className="text-xl font-semibold mb-2 text-orange-700">Datenschutz und Sicherheit</h2>
          <p>
            Die von Google erfassten Daten werden gemäß den Datenschutzbestimmungen von Google verarbeitet. 
            Nähere Informationen zu den Datenschutzbestimmungen von Google, Google Analytics und Firebase finden Sie unter:
          </p>
          <ul className="list-disc ml-6 mt-2">
            <li><a href="https://policies.google.com/privacy?hl=de" target="_blank" rel="noopener noreferrer" className="text-orange-600 hover:underline">https://policies.google.com/privacy?hl=de</a></li>
            <li><a href="https://marketingplatform.google.com/about/analytics/terms/de/" target="_blank" rel="noopener noreferrer" className="text-orange-600 hover:underline">https://marketingplatform.google.com/about/analytics/terms/de/</a></li>
            <li><a href="https://firebase.google.com/support/privacy" target="_blank" rel="noopener noreferrer" className="text-orange-600 hover:underline">https://firebase.google.com/support/privacy</a></li>
          </ul>
          <p className="mt-2">
            Die Firebase Realtime Database unterliegt strengen Sicherheitsregeln, die sicherstellen, dass nur der anonyme 
            Like-Zähler gespeichert wird. Es werden keine personenbezogenen Daten oder Berechnungsdaten in der Datenbank 
            gespeichert. Die Daten werden auf Servern von Google in der EU gespeichert.
          </p>
          <p className="mt-2">
            Sollten Sie Fragen zum Thema Datenschutz haben, können Sie sich gerne an mich wenden.
          </p>
        </section>
        
        <section>
          <h2 className="text-xl font-semibold mb-2 text-orange-700">Ihre Rechte</h2>
          <p>
            Obwohl diese Website als privates Projekt betrieben wird, respektiere ich Ihre Rechte im Umgang mit Ihren Daten:
          </p>
          <ul className="list-disc ml-6 mt-2">
            <li>Sie haben das Recht, der Datenerfassung durch Google Analytics und Firebase zu widersprechen (siehe oben)</li>
            <li>Sie können Auskunft über die zu Ihrer Person gespeicherten Daten verlangen</li>
            <li>Sie können die Löschung Ihrer Daten verlangen</li>
          </ul>
          <p className="mt-2">
            Für die Ausübung dieser Rechte oder bei Fragen zum Datenschutz können Sie sich jederzeit an mich wenden.
          </p>
        </section>
        
        <section>
          <h2 className="text-xl font-semibold mb-2 text-orange-700">Änderung dieser Datenschutzerklärung</h2>
          <p>
            Ich behalte mir das Recht vor, diese Datenschutzerklärung bei Bedarf zu aktualisieren, um
            technischen Entwicklungen Rechnung zu tragen oder rechtliche Änderungen zu berücksichtigen.
          </p>
          <p className="mt-2">
            Stand der Datenschutzerklärung: April 2024
          </p>
        </section>
      </div>
    </div>
  )
}

export default Datenschutz 